<template>
  <div class="molecule-service-card">
    <div class="service-icon">
      <img v-if="imageSrc" :src="imageSrc" :alt="title" class="service-image" />
      <vue-feather
        v-else-if="icon"
        :type="icon"
        size="28"
        stroke-width="1.5"
      ></vue-feather>
    </div>
    <div class="service-content">
      <h3 class="service-title">{{ title }}</h3>
      <p class="service-description">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceCard",
  props: {
    icon: {
      type: String,
      default: null,
    },
    imageSrc: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.molecule-service-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  padding: 1.5rem;
  border-radius: 18px;
  position: relative;
  height: 100%;
  min-height: 400px;
}

.service-icon {
  color: #000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  margin-bottom: 1.5rem;
  width: 100%;
}

.service-image {
  width: 100%;
  height: 195px;
  object-fit: cover;
  object-position: center;
  display: block;
  background: transparent;
}

.service-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  flex-shrink: 0;
}

.service-title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #000;
  margin: 0 0 1rem 0;
  line-height: 1.3;
  width: 100%;
}

.service-description {
  font-size: 1rem;
  color: #666;
  line-height: 1.7;
  margin: 0;
  width: 100%;
}

@media (max-width: 1024px) {
  .molecule-service-card {
    padding: 2rem;
    min-height: 350px;
  }

  .service-title {
    font-size: 1.6rem;
    margin-bottom: 0.875rem;
  }

  .service-image {
    height: 200px;
  }
}

@media (max-width: 768px) {
  .molecule-service-card {
    padding: 2.5rem 1rem 2rem;
    min-height: auto;
    gap: 1.25rem;
  }

  .service-icon {
    margin-bottom: 1.25rem;
    justify-content: center;
  }

  .service-image {
    height: 180px;
    object-position: center;
    margin: 0 auto;
  }

  .service-content {
    align-items: center;
    text-align: center;
  }

  .service-title {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
    text-align: center;
  }

  .service-description {
    font-size: 0.95rem;
    text-align: center;
  }
}
</style>
